import { render, staticRenderFns } from "./DokumanTuruPicker.vue?vue&type=template&id=6ca9c5b7"
import script from "./DokumanTuruPicker.vue?vue&type=script&lang=ts"
export * from "./DokumanTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports